var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    fillRule: "evenodd",
    d: "M1870.42,502.6l4.58,4.6V494.01a2,2,0,1,1,4,0V507.2l4.58-4.6a2,2,0,0,1,2.83-.011s0.01,0.007.01,0.011a2.005,2.005,0,0,1,.01,2.831,0.109,0.109,0,0,0-.01.011l-8,8.005a1.969,1.969,0,0,1-.66.421,2,2,0,0,1-1.52,0,1.969,1.969,0,0,1-.66-0.421l-8-8.005a2.009,2.009,0,0,1,2.84-2.842h0Zm20.58,7.387a2,2,0,0,0-2,2V518a2,2,0,0,1-2,2h-20a2,2,0,0,1-2-2v-6.008a2,2,0,1,0-4,0V518a6,6,0,0,0,6,6h20a6,6,0,0,0,6-6v-6.008A2,2,0,0,0,1891,509.986Z",
    transform: "translate(-1861 -492)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.945241cf.svg";
export { ForwardRef as ReactComponent };